<template>
  <router-view />
  <ChatWidget :api-base="apiBase" />
</template>

<script setup lang="ts">
import { ChatWidget } from '@payopera/chat-widget'

// In local dev we leave it as the default `/api/v1` — vite.config.ts
// proxies it to the staging backend. In production override via env or
// hardcoded origin (e.g. `https://api.payopera.com/v1`).
const apiBase = import.meta.env.VITE_API_BASE ?? '/api/v1'
</script>
